module.exports = "data:image/gif;base64,R0lGODlhEAAQANUAAAAAAP///7GxsdPT0+jo6LCwsMDAwODg4Li4uMjIyEhISKioqLi4uKCgoLCwsMDAwNDQ0MjIyNjY2Ojo6Pf392FhYYeHh7i4uKKior29vYCAgKSkpH9/f1hYWHp6eoyMjIyMjExMTGZmZrKysvDw8JmZmXNzc////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAACcALAAAAAAQABAAAAZxwJNwSBSOTMWkUFOxKIugTyjzHHo4HQ11mOh2HxpN54IpJgLoAMjTqZSLj/RatIgokgb0xuMJNBSARQwBAx0gaQ1/RQgBJQJoFBMEikQOaQEUJBMHlEMFaImaBBKdQguJgIkHEKUnf3cnqa9VQ4G0tEEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/edit_other_pc.gif
// module id = Yt8C
// module chunks = 1